import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_20: FaireProductEntity = {
  token: "caden-lane-20",
  type: "product",
  name: "Cuddle Plush Friends",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/c9c2909ab0ba1e04fb2cb4c0f5b8963d5d76f592039f8ecbfa183a3b686d3d97.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 20,
  msrpDollars: 40,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
